var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('article',{staticClass:"modal-pharmacy"},[_c('RPHButton',{attrs:{"type":"inline"},on:{"click":_vm.toggleModal}},[_c('CloseIcon')],1),_vm._v(" "),_c('RPHContactForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }